// UploadAvatar component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Dropzone from 'dropzone'

import Avatar from '../../common/avatar/avatar.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import ProgressBar from '../../common/progress_bar/progress_bar.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class UploadAvatar extends Component {
  static get propTypes () {
    return {
      image: PropTypes.string,
      label: PropTypes.string,
      uploadSuccess: PropTypes.func,
      uploadError: PropTypes.func,
      className: PropTypes.string,
      iconDelete: PropTypes.string,
      iconUpload: PropTypes.string,
      onDeleteClick: PropTypes.func,
      defaultImage: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      image: '',
      imageData: '',
      label: '',
      uploadSuccess: null,
      uploadError: null,
      className: 'upload-common',
      iconDelete: 'header-upload-delete',
      iconUpload: 'header-upload',
      onDeleteClick: null,
      defaultImage: '/images/common/upload.png'
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      progressValue: 0
    }
  }

  componentDidMount () {
    const clsNme = `.${this.props.className}`
    const myDropzone = new Dropzone(`div${clsNme}`, {
      paramName: 'uri',
      maxFilesize: 10, // MB
      url: '/api/uploads',
      uploadMultiple: false,
      previewsContainer: '.upload-avatar',
      previewTemplate: '<div class="dz-preview"></div>',
      hiddenInputContainer: clsNme,
      clickable: [`${clsNme} > .act-avatar-upload`]
    })

    myDropzone.on('error', this._onError.bind(this))
    myDropzone.on('uploadprogress', this._onProgress.bind(this))
    myDropzone.on('success', this._onSuccess.bind(this))
  }

  render () {
    let uploader = null
    if (this.state.progressValue > 0) {
      uploader = (
        <div className='upload-progress'>
          <ProgressBar
            value={this.state.progressValue}
            mode='determinate'
            min={0}
            max={100}
            type='circular'
            className='avatar-progress'
          />
        </div>
      )
    }

    let label = null
    if (this.props.label) {
      label = (
        <h3 className='upload-avatar-label'>
          <IntlMessage ident={this.props.label} />
        </h3>
      )
    }

    const classes = classnames('', {
      'upload-avatar-hidden': this.state.progressValue > 0
    })

    let avatarImage = this.props.defaultImage
    if (this.state.imageData) {
      avatarImage = this.state.imageData
    } else if (this.props.image) {
      avatarImage = this.props.image
    }

    let avatarDelete = ''
    if (
      this.state.imageData ||
      (this.props.image && this.props.image !== this.props.defaultImage)
    ) {
      avatarDelete = (
        <IconButton
          type='primary'
          icon={this.props.iconDelete}
          canHover={false}
          className='act-avatar-delete'
          onClick={this._onDeleteClick.bind(this)}
        />
      )
    }

    return (
      <div className={`upload-avatar ${this.props.className}`}>
        {avatarDelete}
        <Avatar imageUrl={avatarImage} className={classes} />
        <IconButton
          type='primary'
          icon={this.props.iconUpload}
          canHover={false}
          className='act-avatar-upload'
        />
        {uploader}
        {label}
      </div>
    )
  }

  /* Public Functions */
  _onSuccess (file, message, _e) {
    this.setState({ progressValue: 0, imageData: message.uri })
    if (this.props.uploadSuccess) {
      this.props.uploadSuccess(file, message)
    }
  }

  _onError (file, message, _e) {
    if (this.props.uploadError) {
      this.props.uploadError(file, message)
    }
  }

  _onProgress (file, progress, _e) {
    this.setState({ progressValue: progress })
  }

  _onDeleteClick () {
    this.setState({ imageData: '' })

    if (this.props.onDeleteClick) {
      this.props.onDeleteClick()
    }
  }
}

export default UploadAvatar
